<app-temp-modal-cadastro #modalCadastro (closed)="onClose()" [textHeader]="textHeader">
  <form [formGroup]="cadastroForm" (ngSubmit)="submitForm()">
    <div class="row">
      <div class="form-group col-sm-12">
        <label for="form_nome" class="label-required">Nome</label>
        <input id="form_nome" [disableControl]="loading['registro']" type="text" class="form-control" formControlName="nome"
          maxlength="30" />
        <show-errors [control]="cadastroForm.controls.nome"></show-errors>
      </div>

      <div class="form-group col-sm-12" rem5 combobox [type]="'markups'" [loading]="loading" 
        [form]="cadastroForm" formControlName="markupId" appendTo=".modal-content">
      </div>
    </div>

    <div class="alert alert-danger" *ngIf="errors">
      <span>{{ errors }}</span>
    </div>

    <button [disabled]='loading["registro"]' type="submit" (click)="validaForm()" class="btn btn-primary ripple light">
      <app-loading [texto]="'Salvar'" [loading]="loading['registro']"></app-loading>
    </button>
    <button [disabled]='loading["registro"]' type="button" class="btn btn-default ripple"
      (click)="modalCadastro.hide()">Cancelar</button>
  </form>
</app-temp-modal-cadastro>